import { TranslationKeys } from "./en";

export const fr: TranslationKeys = {
  // Welcome Page
  welcome: {
    title: "Interphone avec Code QR Intelligent",
    subtitle: "Système d'Accès Sécurisé au Bâtiment",
    welcomeTitle: "Bienvenue",
    description:
      "Veuillez appuyer sur le bouton ci-dessous pour commencer à utiliser le système d'interphone",
    tapToStart: "Appuyez pour Commencer",
    footerText: "Touchez l'écran pour commencer",
  },

  // Home Page
  home: {
    welcome: "Bienvenue",
    verifyingQR: "Vérification du code QR...",
    verified: "Code QR vérifié ✓ session établie",
    error: "Erreur",
  },

  // Directory
  directory: {
    title: "Répertoire",
    searchPlaceholder: "Rechercher des chambres...",
    noRooms: "Aucune chambre trouvée",
    floor: "Étage",
    calling: "Appel en cours...",
    roomsCount: "{count} sur {total} chambres",
  },

  // Number Pad
  numberPad: {
    deliveryTitle: "Code PIN de livraison",
    roomTitle: "Code PIN de chambre",
    selectDeliveryService: "Sélectionner le service de livraison",
    selectRoom: "Sélectionner la chambre",
    placeholder: "Veuillez sélectionner...",
    clear: "Effacer",
    confirm: "Confirmer",
    errorMinDigits: "Veuillez entrer au moins 4 chiffres",
    hintDelivery: "Veuillez entrer le code PIN de livraison.",
    hintRoom: "Veuillez entrer le code PIN de la chambre.",
    hintMinMax: "Entre 4 et 6 chiffres.",
  },

  // Guest Pass
  guestPass: {
    title: "Laissez-passer Invité",
    description:
      "Veuillez entrer votre code PIN d'invité pour accéder au bâtiment",
    clear: "Effacer",
    confirm: "Confirmer",
    errorMinDigits: "Veuillez entrer au moins 4 chiffres",
    hint1: "Entrez le code PIN d'invité qui vous a été fourni",
    hint2: "Minimum 4 chiffres, maximum 8 chiffres",
    backToHome: "Retour à l'Accueil",
    welcomeMessage: "Bienvenue {name}! La porte s'ouvre...",
    doorFailedToOpen:
      "Code PIN vérifié mais la porte n'a pas pu s'ouvrir. Veuillez contacter la gestion.",
    sessionMissing:
      "Le jeton de session est manquant. Veuillez actualiser la page ou scanner à nouveau le code QR.",
    invalidPin: "Code PIN d'invité invalide. Veuillez réessayer.",
    sessionExpired:
      "Session expirée. Veuillez actualiser la page ou scanner à nouveau le code QR.",
    errorOccurred: "Une erreur s'est produite. Veuillez réessayer.",
  },

  // Visitor Check-In
  visitorCheckIn: {
    title: "Enregistrement des Visiteurs",
    back: "Retour",
    firstName: "Prénom",
    lastName: "Nom de Famille",
    company: "Entreprise",
    whoToVisit: "Qui Visiter",
    firstNamePlaceholder: "Entrez le prénom du visiteur",
    lastNamePlaceholder: "Entrez le nom de famille du visiteur",
    companyPlaceholder: "Entrez l'entreprise du visiteur",
    whoToVisitPlaceholder: "Qui le visiteur visite-t-il?",
    firstNameRequired: "Le prénom est requis",
    lastNameRequired: "Le nom de famille est requis",
    companyRequired: "L'entreprise est requise",
    whoToVisitRequired: "Le champ visiteur qui est requis",
    cancel: "Annuler",
    checkIn: "Enregistrer",
    checkingIn: "Enregistrement en cours...",
    successMessage:
      "Enregistrement du visiteur réussi pour {firstName} {lastName}",
    errorMessage: "Erreur lors de l'enregistrement. Veuillez réessayer.",
  },

  // Video Call Page
  videoCall: {
    callingManager: "Appel du Gestionnaire",
    callingResident: "Appel de {name}",
    room: "Chambre {room}",
    videoCall: "Appel Vidéo",
    endCall: "Terminer l'Appel",
    callError: "Erreur d'Appel",
    invalidCallData: "Données d'appel invalides",
    goBack: "Retour",
    callEnded: "Appel terminé",
    otherPartyHungUp: "L'autre partie a raccroché",
    ok: "OK",
    noAnswer: "Personne n'a répondu",
    noAnswerMessage:
      "Il semble que personne n'ait décroché l'appel dans les {seconds} secondes. Veuillez réessayer plus tard.",
    autoClosing: "Fermeture automatique dans {count} secondes...",
    mute: "Muet",
    unmute: "Activer le Son",
    turnOffVideo: "Désactiver la vidéo",
    turnOnVideo: "Activer la vidéo",
  },

  // Messages
  messages: {
    error: "Erreur",
    success: "Succès!",
    sessionExpired: "Session Expirée",
    sessionExpiredMessage:
      "Votre session a expiré après 5 minutes. Veuillez actualiser la page ou scanner à nouveau le code QR.",
    sessionExpiredShort:
      "Votre session a expiré. Veuillez actualiser la page ou scanner à nouveau le code QR.",
    sessionExpiredContinue:
      "Votre session a expiré. Veuillez actualiser la page ou scanner à nouveau le code QR pour continuer.",
    pleaseVerifyQR: "Veuillez d'abord vérifier le code QR",
    pleaseSelectDelivery: "Veuillez sélectionner un service de livraison",
    pleaseSelectRoom: "Veuillez sélectionner une chambre",
    deliveryPinVerified:
      "Code PIN de livraison vérifié et la porte s'ouvre pour {name}",
    roomPinVerified:
      "Code PIN de chambre vérifié et la porte s'ouvre pour la Chambre {name}",
    doorFailedToOpen: "Échec de l'Ouverture de la Porte",
    doorFailedMessage:
      "Code PIN vérifié mais la porte n'a pas pu s'ouvrir. Veuillez contacter la gestion.",
    pinVerificationFailed: "Échec de la Vérification du Code PIN",
    invalidPin: "Code PIN invalide",
    pinVerificationError: "Erreur de vérification du code PIN",
    callRoomFailed: "Échec de l'Appel de la Chambre",
    callRoomError: "Erreur d'Appel de la Chambre",
    callManagerFailed: "Échec de l'Appel du Gestionnaire",
    callManagerError: "Erreur d'Appel du Gestionnaire",
  },

  // Button Labels
  buttons: {
    directory: "Répertoire",
    delivery: "Code PIN de livraison",
    doorPin: "Code PIN de porte",
    guestPass: "Pass invité",
    callReception: "Appeler la réception",
    visitorCheckIn: "Enregistrement des Visiteurs",
  },

  // Common
  common: {
    loading: "Chargement...",
    close: "Fermer",
    cancel: "Annuler",
    confirm: "Confirmer",
    back: "Retour",
    required: "*",
  },

  // Language Switcher
  language: {
    select: "Langue",
    english: "English",
    french: "Français",
    spanish: "Español",
  },
};
